<template src="./vehicledocumentspopup.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  import $ from "jquery";
  import GetcurrencySymbol from "@/assets/js/currency_sign.js";
  export default {
    props: ["NewVehicle", "popupCategory", "popupSubCategory", "type"],
    data() {
      return {
        currency_type : GetcurrencySymbol(),
        Documents: [],
        ViewDocument: {},
        NewDocument: {},
        ShowViewDetailModel: false,
        PopupLoader: false,
        file: "",
        popUpHeading: "",
      };
    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      loadPopupModal(type, heading) {        
        this.popUpHeading = heading;
        var category = "vehicle";
        var sub_category = type;
        if (type == "service") {
          sub_category = "service";
        } else if (type == "brakes") {
          sub_category = "brakes";
        } else if (type == "PMI") {
          sub_category = "PMI";
        }

        if (this.type == "Asset") {
          category = "asset";
        }
        this.NewDocument = {};
        $("#file").val(null);
        this.file = "";
        this.PopupLoader = true;
        Axios.post(Endpoints.Dcoument.Model, {
          token: localStorage.getItem("token"),
          category: category,
          sub_category: sub_category,
        }).then((Response) => {
          this.PopupLoader = false;
          if (Response?.data?.success == true && Response.data.models[0]) {
            var model = Response.data.models[0];
            this.NewDocument.title = this.type + " " + sub_category;
            this.NewDocument.category = model.category;
            this.NewDocument.sub_category = model.sub_category;
            this.NewDocument.fields = JSON.parse(model.fields);
            this.NewDocument.type = category;
            if (this.NewDocument.fields && this.NewDocument.fields.vehicle) {
              this.NewDocument.fields.vehicle.value = this.NewVehicle.vrm;
            }
            if (this.NewDocument.fields && this.NewDocument.fields.asset) {
              this.NewDocument.fields.asset.value =
                this.NewVehicle.name+' ('+this.NewVehicle.serial_number+')';
            }
            for (const index in this.NewDocument.fields) {              
              this.NewDocument.fields[index]["show_field"] = true;
              if (index == "mileage") {
                this.NewDocument.fields["mileage"]["required"] = true;
              }
              if (index == "miles" && this.NewVehicle.service_measurement != 'Miles') {
                this.NewDocument.fields['miles']["show_field"] = false;
              }
              if (index == "hours" && this.NewVehicle.service_measurement != 'Hours') {
                this.NewDocument.fields['hours']["show_field"] = false;
              }

              if(this.type == "Asset" && index == "notes"){
                this.NewDocument.fields['notes']["title"] = "Work done";
              }

            }
          }
        });
       
        
      },
      loadEditData(document) {
        this.NewDocument = {};
        $("#file").val(null);
        this.file = "";
        this.NewDocument.id = document.id;
        this.NewDocument.title = document.title;
        this.NewDocument.category = document.category;
        this.NewDocument.sub_category = document.sub_category;
        if (typeof document.fields === "object") {
          this.NewDocument.fields = document.fields;
        } else {
          this.NewDocument.fields = JSON.parse(document.fields);
        }
        this.NewDocument.type = document.sub_category;
        if (this.NewDocument.fields && this.NewDocument.fields.vehicle) {
          this.NewDocument.fields.vehicle.value = this.NewVehicle.vrm;
        }
        for (const index in this.NewDocument.fields) {
          this.NewDocument.fields[index]["show_field"] = true;
            if (index == "mileage") {
              this.NewDocument.fields["mileage"]["required"] = true;
            }
            if (index == "miles" && this.NewVehicle.service_measurement != 'Miles') {
              this.NewDocument.fields['miles']["show_field"] = false;
            }
            if (index == "hours" && this.NewVehicle.service_measurement != 'Hours') {
              this.NewDocument.fields['hours']["show_field"] = false;
            }
            if(document.category == "asset" && index == "notes"){
                this.NewDocument.fields['notes']["title"] = "Work done";
              }
        }
      },
      SaveDocumentSubmit() {
        var error = false;
        var errorStr = "";
        if (this.NewDocument.fields) {
          for (const [key, ele] of Object.entries(this.NewDocument.fields)) {
            if (this.type == "Vehicle") {
              if (ele.required && (!ele.value || ele.value == "")) {
                error = true;
                errorStr += "<li>Please Enter " + ele.title + "</li>";
              }
              if (key == "mileage" && ele.value <= 0) {
                error = true;
                errorStr += "<li>Mileage should be greator then 0</li>";
              }
            }
            if (this.type == "Trailer" && key != "mileage") {
              if (ele.required && (!ele.value || ele.value == "")) {
                error = true;
                errorStr += "<li>Please Enter " + ele.title + "</li>";
              }
            }
          }
        }
        if (error == true) {
          this.$swal
            .fire("Following Error Found!", errorStr, "error")
            .then(() => {});
        } else {
          if (this.$refs.file.files[0]) {
            this.PopupLoader = true;
            let formData = new FormData();
            formData.append("token", localStorage.getItem("token"));
            formData.append("storage_type", "CFV");
            formData.append("file", this.file);
            Axios.post(Endpoints.File.Upload, formData).then((Response) => {
              this.PopupLoader = false;
              if (Response?.data?.success == true) {
                this.NewDocument.files = Response.data.file;
                this.NewDocument.filename = this.file.name;
                this.AddDocumentSubmit();
              } else {
                this.$swal
                  .fire("Error in File Uploading", "", "error")
                  .then(() => {});
              }
            });
          }else{
            this.AddDocumentSubmit();
          }
        }
      },
      DeleteDocumentData(document_id) {
        this.$swal
          .fire({
            title: "Are you sure You want to delete?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal.fire({
                title: "Deleting...",
                text: "Please wait...",
                showConfirmButton: false,
                allowOutsideClick: false,
              });
              Axios.post(Endpoints.Dcoument.Delete, {
                token: localStorage.getItem("token"),
                document_id: document_id,
              }).then((Response) => {
                if (Response?.data?.success == true) {
                  this.$swal.close();
                  this.$parent.LoadHistory();
                  this.$swal
                    .fire("Document Deleted Successfully", "", "success")
                    .then(() => {});
                } else {
                  this.$swal
                    .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                    .then(() => {});
                }
              });
            }
          });
      },
      AddDocumentSubmit() {
        if (this.type == "Asset") {
          this.NewDocument.asset_id = this.NewVehicle.id;
          this.NewDocument.vehicle_id = 0;
        } else {
          this.NewDocument.vehicle_id = this.NewVehicle.id;
          this.NewDocument.asset_id = 0;
        }
        this.NewDocument.export_type = 1;
        this.NewDocument.scope = 1;
        this.NewDocument.type = this.type;
          var Heading = "Adding ";
          if (this.NewDocument.id && this.NewDocument.id > 0) {
            Heading = "Updating ";
          }

          this.$swal.fire({
            title: Heading + this.type + " " + this.popupSubCategory + "...",
            text: "Please wait...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          this.PopupLoader = true;
          this.NewDocument.token = localStorage.getItem("token");
          Axios.post(Endpoints.Dcoument.Create, this.NewDocument).then(
            (Response) => {
              this.PopupLoader = false;
              if (Response?.data?.success == true) {
                this.ShowAddDocument = false;
                this.$parent.LoadHistory();
                $("#AddDocumentPopup .btn-danger").trigger("click");
                var msg =
                  this.type +
                  " " +
                  this.popupSubCategory +
                  " Added Successfully";
                if (this.NewDocument.id && this.NewDocument.id > 0) {
                  msg =
                    this.type +
                    " " +
                    this.popupSubCategory +
                    " Updated Successfully";
                }
                this.$swal.fire(msg, "", "success").then(() => {});
                this.NewDocument = {};
              } else {
                this.$swal
                  .fire(Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            }
          );
      },
    },
  };
</script>
<style scoped>
  .modal-title {
    text-transform: capitalize;
  }
  .displayNone {
    display: none !important;
  }
  input[type="checkbox"] {
    max-width: 30px;
  }
</style>
